import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

/**
 * CanonicalUrl component for adding canonical URL meta tags to pages
 *
 * This component helps search engines understand the preferred version of a page
 * when multiple URLs might show similar content, avoiding duplicate content issues.
 *
 * @param {Object} props - Component props
 * @param {string} props.url - Optional explicit canonical URL to use (overrides automatic URL generation)
 * @returns {JSX.Element} - Helmet component with canonical link tag
 */
const CanonicalUrl = ({ url }) => {
  const location = useLocation()

  // Base URL of the website
  const baseUrl = 'https://conversoriaecnae.es'

  // If a specific URL is provided, use it; otherwise, construct from current path
  const canonicalUrl = url || `${baseUrl}${location.pathname}`

  return (
    <Helmet>
      <link rel='canonical' href={canonicalUrl} />
    </Helmet>
  )
}

export default CanonicalUrl
